export default ({ data, editorPermissions }) => {
  const { data: learnerPermissions } = data;

  const editor = { ...editorPermissions.data };

  let learner = { ...learnerPermissions };

  if (!learnerPermissions) {
    learner = {
      access_type: 'none',
      permissionable_id: null,
      permissionable_type: 'ContentListItem',
      accessible_by: [],
    };

    if (editor.accessible_by === []) {
      return { learner, editor };
    }
  }

  const transformedLearnerData = learnerPermissions?.accessible_by.map((item) => ({
    avatar: item.avatar_path,
    code: item.code,
    membersCount: item.metadata.number_of_members,
    name: item.name,
    type: item.type,
    id: item.id,
  }));
  const transformedEditorData = editor.accessible_by.map((item) => ({
    avatar: item.avatar_path,
    code: item.code,
    eligibleMembers: item.metadata.number_of_eligible_members,
    jobTitle: item.metadata.job_title || null,
    type: item.type,
    name: item.name,
    id: item.id,
  }));

  return {
    learner: {
      access_type: learner.access_type,
      permissionable_id: learner.permissionable_id,
      permissionable_type: learner.permissionable_type,
      accessible_by: transformedLearnerData || [],
    },
    editor: {
      accessible_by: transformedEditorData || editor.accessible_by,
      permissionable_id: editor.permissionable_id,
      permissionable_type: editor.permissionable_type,
    },
  };
};
